import React from 'react';

import { PRIVACY_POLICY_URL } from '../../../constants/constants';
import { useAuth } from '../../../contexts/AuthContext';

function LoginAuthForm(): JSX.Element {
  const { signIn, loginError } = useAuth();

  return (
    <div className="w-1/3 p-4 sm:p-6 lg:p-8 bg-white flex items-center justify-center">
      <div className="w-full max-w-sm flex flex-col items-center">
        <img src="svg/bc_logo.svg" alt="BeautifulCode" className="h-7 mb-8" />
        <h2 className="text-sm text-black font-nunito font-light leading-6 text-center mb-3">
          Welcome to BeautifulCode Experience App
        </h2>
        <button
          type="button"
          onClick={() => {
            signIn().catch(() => {});
          }}
          className="w-full h-10 bg-cream-light flex items-center justify-center gap-2 px-4 py-2 sm:p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors mb-8 sm:mb-12 lg:mb-16 shadow-sm"
        >
          <img src="svg/google_icon.svg" alt="Google" />
          <span className="text-sm text-gray-dark font-nunito font-semibold leading-5">
            Login In with Google
          </span>
        </button>
        {loginError && (
          <p className="w-full text-xs text-red-500 font-nunito font-normal leading-5 text-center mb-4">
            {loginError}
          </p>
        )}
        <p className="w-full text-xs text-gray-light font-nunito font-normal leading-5 text-center">
          See how we use your data in our{' '}
          <a
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-light underline"
          >
            privacy policy.
          </a>
          If you&apos;re unable to login with your Gmail account, please contact
          our{' '}
          <a
            href="mailto:sai@beautifulcode.in"
            className="text-gray-light underline"
          >
            system-administrator
          </a>{' '}
          for assistance.
        </p>
      </div>
    </div>
  );
}

export default LoginAuthForm;
